<template>
  <v-col class="offer-stat d-flex flex-column pa-0" cols="5" sm="4" md="3">
    <h4
      class="offer-stat__title ma-0"
      :class="{
        'offer-stat--disabled': disabled
      }"
    >{{ title }}</h4>
    <v-spacer></v-spacer>
    <p
      class="offer-stat__number ma-0"
      :class="{
        'offer-stat--disabled': disabled
      }"
    >
      {{ number }}
    </p>
    <v-spacer></v-spacer>
  </v-col>
</template>

<script>
export default {
    name: "OfferStat",
    props: ["title", "number", "disabled"]
};
</script>
